"use strict";

exports.__esModule = true;
exports.createDataItemEChartProps = void 0;
var _SeriesOptions = require("./SeriesOptions");
var _dataSeries = require("./dataSeries");
var _valueFormatters = require("./valueFormatters");
var _timeFormatters = require("./timeFormatters");
var _dataToTableConverter = require("./dataToTableConverter");
var createDataItemEChartProps = exports.createDataItemEChartProps = function createDataItemEChartProps(_ref) {
  var _options$chartItems, _options$chartItems$p, _options$chartItems2, _options$controls, _options$title, _options$controls2, _options$controls3, _options$visualMap;
  var series = _ref.series,
    device = _ref.device,
    dataItems = _ref.dataItems,
    _ref$yAxisFormatter = _ref.yAxisFormatter,
    yAxisFormatter = _ref$yAxisFormatter === void 0 ? _valueFormatters.defaultValueFormatter : _ref$yAxisFormatter,
    xAxisFormatter = _ref.xAxisFormatter,
    options = _ref.options,
    timezone = _ref.timezone,
    translate = _ref.translate,
    downloadCSVData = _ref.downloadCSVData,
    useZeroAsBase = _ref.useZeroAsBase,
    targetValue = _ref.targetValue,
    predefinedMaxValue = _ref.predefinedMaxValue,
    _ref$uiModern = _ref.uiModern,
    uiModern = _ref$uiModern === void 0 ? false : _ref$uiModern;
  var preparedSeries = (0, _dataSeries.getDataSeries)(series, device, dataItems, options, targetValue, yAxisFormatter, uiModern);
  var tableData = (0, _dataToTableConverter.convertDataForTableFormat)(series, timezone, device, dataItems, yAxisFormatter);
  var props = {
    title: (0, _SeriesOptions.getTitleOptions)(options == null ? void 0 : options.title),
    grid: (0, _SeriesOptions.getGridOptions)(options == null || (_options$chartItems = options.chartItems) == null ? void 0 : _options$chartItems.layout, (_options$chartItems$p = options == null || (_options$chartItems2 = options.chartItems) == null ? void 0 : _options$chartItems2.props.map(function (item) {
      var _item$appearance$show, _item$appearance;
      return (_item$appearance$show = item == null || (_item$appearance = item.appearance) == null ? void 0 : _item$appearance.showGrid) != null ? _item$appearance$show : true;
    })) != null ? _options$chartItems$p : [], !(options != null && (_options$controls = options.controls) != null && _options$controls.hideLegend), options == null || (_options$title = options.title) == null ? void 0 : _options$title.show, uiModern),
    tooltip: {
      show: !(options != null && (_options$controls2 = options.controls) != null && _options$controls2.hideTooltip),
      trigger: "axis",
      axisPointer: {
        type: "shadow",
        label: {
          formatter: (0, _timeFormatters.tooltipAxisPointerFormatter)(timezone)
        }
      },
      valueFormatter: yAxisFormatter
    },
    legend: Object.assign({
      show: !(options != null && (_options$controls3 = options.controls) != null && _options$controls3.hideLegend)
    }, uiModern ? {
      top: 0,
      right: 0,
      icon: "rect",
      itemWidth: 14,
      itemHeight: 2
    } : {
      bottom: 0
    }),
    toolbox: (0, _SeriesOptions.getToolboxOptions)(options == null ? void 0 : options.toolbox, translate, function () {
      return downloadCSVData(device.name, tableData);
    }, tableData)
  };

  // should only be set when show variable is set as true
  if (options != null && (_options$visualMap = options.visualMap) != null && _options$visualMap.show) {
    props.visualMap = (0, _SeriesOptions.getVisualMapOptions)(options == null ? void 0 : options.toolbox, options == null ? void 0 : options.visualMap);
  }
  var _getAxisOptions = (0, _SeriesOptions.getAxisOptions)(options == null ? void 0 : options.chartItems, timezone, yAxisFormatter, xAxisFormatter, useZeroAsBase, targetValue, predefinedMaxValue),
    xAxis = _getAxisOptions.xAxis,
    yAxis = _getAxisOptions.yAxis;
  props.xAxis = xAxis;
  props.yAxis = yAxis;
  props.series = preparedSeries;
  return props;
};